import { title } from 'process'
import './DetailsTitleBar.css'

interface Props
{
	title: String|undefined
    imageSrc: String|undefined
    backgroundColor: string|undefined
}

const DetailsTitleBar = (props: Props) =>
{
	return (
        <div style={{backgroundColor: props.backgroundColor}}>
            <div style={{backgroundColor: props.backgroundColor}} className="detailsTitleBar-main-container" >
                <div style={{backgroundColor: props.backgroundColor}} className='detailsTitleBar-image'>
                    <img src={`${props.imageSrc}`} alt='title-image'></img>
                </div>
                <div style={{backgroundColor: props.backgroundColor}} className='detailsTitleBar-title'>
                    {props.title}
                </div>
            </div>
        </div>
	)
}

export default DetailsTitleBar
